import { customAlphabet } from "nanoid";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Łączy klasy CSS z tailwind-merge
 */
export function cn(...inputs: ClassValue[]) {
  // Temporarily bypass twMerge for debugging
  return clsx(inputs);
  // Original: return twMerge(clsx(inputs));
}

export const nanoid = customAlphabet("abcdefghijklmnopqrstuvwxyz0123456789");
